import { Result } from "antd";
import strings from "localisation/strings";
import React from "react";

const NotFound = () => (
  <Result status="404" title="404" subTitle={strings("notFound.subtitle")} />
);

export default NotFound;
